import {
    DEFAULT_CURRENCY,
    TRANSACTION_STATUS,
    TRANSACTION_TYPE,
} from '../../../utils/constants/commonValues';

import moment from 'moment';

function TransactionList(data) {
    this.tableData = this.createTableData(data);
    this.pagination = this.createPaginationData(data);
}

TransactionList.prototype = Object.assign(TransactionList.prototype, {
    createTableData(tableData) {
        return (
            tableData &&
            tableData.transactionViewList &&
            tableData.transactionViewList.map(row => this.createRow(row))
        );
    },
    createPaginationData(data) {
        if (data) {
            const { totalElements } = data;
            return {
                hasNextPage: false,
                hasPreviousPage: false,
                pageNumber: 0,
                pageSize: 10,
                sortingCriteria: '',
                totalNumberOfPages: 0,
                totalNumberOfRecords: totalElements,
            };
        }
        return {};
    },
    createRow(row) {
        const {
            customerID,
            customerName,
            maskedCardNumber,
            merchantId,
            merchantName,
            message,
            orderId,
            paymentMode,
            platform,
            rrnArn,
            statusCode,
            transactionAmount,
            transactionDateAndTime,
            transactionReferenceNumber,
            transactionStatus,
            transactionType,
            splitPay,
            payeeVpa,
            payerVpa,
            loanAmount,
            emiAmount,
            emiBankInterest,
            emiValue,
            emiInterestPaid,
            tenure,
            transactionSubMode,
            accountType,
            terminalId,
        } = row;
        return {
            customerID: customerID || '-',
            customerName: customerName || '-',
            maskedCardNumber: maskedCardNumber || '-',
            merchantName: merchantName || '-',
            merchantId: merchantId || '',
            message: message || '-',
            orderId: orderId || '-',
            paymentMode: paymentMode || '-',
            platform: platform || '-',
            rrnArn: rrnArn || '-',
            statusCode: statusCode || '-',
            transactionAmount: transactionAmount
                ? `${DEFAULT_CURRENCY} ${transactionAmount}`
                : '-',
            amount: transactionAmount,
            transactionDateAndTime:
                moment(
                    transactionDateAndTime,
                    'YYYY-MM-DD HH:mm:ss.SSSSSS'
                ).format('YYYY-MM-DD HH:mm:ss') || '-',
            transactionReferenceNumber: transactionReferenceNumber || '-',
            transactionStatus: this.getTransactionStatus(transactionStatus),
            transactionType: this.getTransactionType(transactionType),
            splitPay: splitPay || [],
            payeeVpa,
            payerVpa,
            loanAmount,
            emiAmount,
            emiBankInterest,
            emiValue,
            emiInterestPaid,
            tenure,
            transactionSubMode,
            instrumentInfo:
                maskedCardNumber && maskedCardNumber !== '-'
                    ? maskedCardNumber
                    : payerVpa,
            accountType,
            terminalId: terminalId || '-',
        };
    },
    getTransactionStatus(status) {
        if (!status) {
            return '-';
        }
        return TRANSACTION_STATUS[status];
    },
    getTransactionType(type) {
        if (!type) {
            return '-';
        }

        return TRANSACTION_TYPE[type];
    },
});

export default TransactionList;
